import React from 'react';
import { Outlet } from 'react-router-dom';
import SuperAdminHeader from '../components/SuperAdminHeader';

const SuperAdminLayout = () => (
  <>
    <SuperAdminHeader />
    <Outlet />
  </>
);

export default SuperAdminLayout;